import {
  TComponentKeys,
} from '@/types/openapi-type.ts';

const tooltip: TComponentKeys<'AuditTrailSettings'> = {
  isEnabled: 'Determines whether the audit trail is enabled. If it is disabled, no events will be recorded.',
  retentionPeriodDays: 'Defines how long events are retained. Old events are deleted hourly. The maximum period is 31 days.',
};

export default {
  tooltip,
};
